import { render, staticRenderFns } from "./ModuleLayoutTest.vue?vue&type=template&id=2a7d632e&scoped=true"
import script from "./ModuleLayoutTest.vue?vue&type=script&lang=ts"
export * from "./ModuleLayoutTest.vue?vue&type=script&lang=ts"
import style0 from "./ModuleLayoutTest.vue?vue&type=style&index=0&id=2a7d632e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7d632e",
  null
  
)

export default component.exports